var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { "pa-2": "", xs12: "" } },
    [
      _c(
        "v-card",
        {
          staticClass: "sb_component_card",
          attrs: { id: _vm.parentContextId + "_Card", height: "100%" }
        },
        [
          _c(
            "v-card-title",
            { staticClass: "sb_component_card_title" },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md6: "", lg9: "" } },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "", "nudge-right": "30" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attr = ref.attr
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-inline-flex align-center GSSecHeadingCol",
                                    attrs: { wrap: "" }
                                  },
                                  [
                                    _vm.moduleIcon
                                      ? _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                class: [
                                                  "mr-2",
                                                  "material-icons-outlined",
                                                  _vm.moduleIcon,
                                                  _vm.moduleTooltips[
                                                    _vm.moduleIcon
                                                  ]
                                                    ? "module-icon"
                                                    : ""
                                                ]
                                              },
                                              "v-icon",
                                              attr,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.moduleIcon) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("h4", { class: _vm.titleClass }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.title) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._t("config"),
                                    _vm._v(" "),
                                    _vm._t("after-title")
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          attrs: { id: _vm.parentContextId + "_Icon_Tooltip" }
                        },
                        [_vm._v(_vm._s(_vm.moduleTooltips[_vm.moduleIcon]))]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.lastReportRefresh
                ? _c("v-flex", { attrs: { xs12: "", md6: "", lg9: "" } }, [
                    _c("h5", { staticClass: "last-refresh" }, [
                      _vm._v(
                        "\n          Last Refreshed On: " +
                          _vm._s(_vm.lastReportRefresh) +
                          " (UTC)\n        "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "Global-Panel-Content",
                  attrs: { xs12: "", md6: "", lg3: "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "justify-end": "" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "\n              UDM_GS_HeaderIcons\n              d-inline-flex\n              align-center\n              card-header-actions\n            "
                        },
                        [
                          _vm._t("actions"),
                          _vm._v(" "),
                          _vm.displayOrder > 0
                            ? _c("move-card-up-down", {
                                attrs: { "id-prefix": _vm.parentContextId },
                                on: {
                                  MoveUp: function($event) {
                                    return _vm.$emit(
                                      "MoveCardUp",
                                      _vm.displayOrder
                                    )
                                  },
                                  MoveDown: function($event) {
                                    return _vm.$emit(
                                      "MoveCardDown",
                                      _vm.displayOrder
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardConfig.pin
                            ? _c("pin-unpin-button", {
                                attrs: {
                                  "card-name": _vm.parentContextId,
                                  "id-prefix": _vm.parentContextId,
                                  "pin-parameters": _vm.pinParameters
                                },
                                on: {
                                  pinned: function(v) {
                                    return _vm.$emit("pinned", v)
                                  },
                                  "pin-error": function(e) {
                                    return _vm.errors.push(
                                      "Error pinning card: " + e.message
                                    )
                                  },
                                  "try-pin": function($event) {
                                    _vm.errors = []
                                    _vm.$emit("try-pin")
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardConfig.help && !_vm.hideHelpIcon
                            ? _c("quick-help-button", {
                                attrs: {
                                  "user-guide-identifier":
                                    _vm.userGuideIdentifier,
                                  "id-prefix": _vm.parentContextId
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cardConfig.minimize && !_vm.isInPanel
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "text-center card-expand-collapse-button"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        id: _vm.parentContextId + "-btn-expand",
                                        icon: "",
                                        flat: "",
                                        depressed: "",
                                        fab: ""
                                      },
                                      on: { click: _vm.toggleCard }
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attr = ref.attr
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            class: {
                                                              "material-icons-round": true
                                                            }
                                                          },
                                                          "v-icon",
                                                          attr,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.isCardExpanded
                                                                ? "expand_less"
                                                                : "expand_more"
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2073994817
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                id:
                                                  _vm.parentContextId +
                                                  "_expand_tooltip"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isCardExpanded
                                                    ? "Collapse this card"
                                                    : "Expand this card"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.actionButtons, function(item) {
                            return _c(
                              "v-list-item",
                              { key: item.event, staticClass: "text-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      id:
                                        _vm.parentContextId +
                                        "-btn-" +
                                        item.icon,
                                      disabled: item.disabled,
                                      icon: "",
                                      flat: "",
                                      depressed: "",
                                      fab: ""
                                    },
                                    on: { click: item.onClick }
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attr = ref.attr
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          class:
                                                            "material-icons-round " +
                                                            item.className
                                                        },
                                                        "v-icon",
                                                        attr,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(item.icon) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(item.buttonName))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.panelButtons, function(btn, idx) {
                            return _c(
                              "v-btn",
                              {
                                key: idx,
                                class: btn.className,
                                attrs: {
                                  icon: "",
                                  flat: "",
                                  depressed: "",
                                  fab: ""
                                },
                                on: { click: btn.onClick }
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            var attr = ref.attr
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      class:
                                                        "material-icons-round " +
                                                        btn.className
                                                    },
                                                    "v-icon",
                                                    attr,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(btn.icon) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(btn.buttonName))])
                                  ]
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "justify-start": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "", lg4: "" } },
                    [_vm._t("below-title")],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "sb_component_card_body Global-Panel-Content": true,
                "card-collapsed": !_vm.isCardExpanded,
                "card-transitioning": _vm.isTransitioning
              },
              attrs: { "data-cardHeight": _vm.cardHeight }
            },
            [
              _c(
                "v-card-text",
                {
                  class: {
                    "pt-1": _vm.cardConfig.filter || _vm.cardConfig.download,
                    "h-100-p": _vm.$slots.sphereTable
                  }
                },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "sb_component_card_time_loader",
                      attrs: {
                        value: _vm.longLoadTime && _vm.loading,
                        color: "info",
                        outline: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentLoadingMessage) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.initialLoadComplete && _vm.loading
                    ? _c("v-progress-linear", {
                        staticClass: "sb_component_card_loader_bar",
                        attrs: { indeterminate: true }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("status-display-bar", { attrs: { error: _vm.errors } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "p-relative",
                      class: { "h-100-p": _vm.$slots.sphereTable }
                    },
                    [
                      _vm.initialLoadComplete && _vm.loading
                        ? _c("div", { staticClass: "sb-overlay" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("top-of-body"),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          class: { "h-100-p": _vm.$slots.sphereTable },
                          attrs: { row: "", wrap: "" }
                        },
                        [
                          !!_vm.$slots.chart && !_vm.loadingError
                            ? _c(
                                "v-flex",
                                {
                                  class: {
                                    "pr-2": _vm.hasTableSlot,
                                    xs12: true,
                                    sm12: true,
                                    md5: _vm.hasTableSlot,
                                    md12: !_vm.hasTableSlot,
                                    "slot-chart": true
                                  }
                                },
                                [
                                  _c(
                                    "skeleton-loader",
                                    {
                                      attrs: {
                                        loading: !_vm.initialLoadComplete,
                                        type: "chart"
                                      }
                                    },
                                    [_vm._t("chart")],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !!(_vm.$slots.table || _vm.$slots.sphereTable) &&
                          !_vm.loadingError
                            ? _c(
                                "v-flex",
                                {
                                  class: {
                                    "pl-2": _vm.hasChartSlot,
                                    xs12: true,
                                    sm12: true,
                                    md7: _vm.hasChartSlot,
                                    md12: !_vm.hasChartSlot,
                                    "slot-table": true
                                  }
                                },
                                [
                                  _vm._t("sphereTable"),
                                  _vm._v(" "),
                                  _vm.$slots.table
                                    ? _c(
                                        "skeleton-loader",
                                        {
                                          attrs: {
                                            loading: !_vm.initialLoadComplete,
                                            type: "table"
                                          }
                                        },
                                        [_vm._t("table")],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }